import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";
import LoginLoaderButton from "../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import { GetCountry } from "../../../../redux/master/action";
import { disabledStyle } from "../../../Common/ClickDisable";
import PortfolioImages from "./PortfolioImages";
import AsteriskLabel from "../../../Common/AsteriskLabel";
import { filesvalidationforstatusbase } from "../../../Common/commonvalidation";

const bxpDatatomap = [
  { title: (<>Add Product Media <AsteriskLabel /></>), name: "files", placeholder: "Drag and drop or Browse file" },
  { title: (<>Country <AsteriskLabel /></>), name: "country_id", placeholder: "Select Country" },
  { title: (<>Product condition <AsteriskLabel /></>), name: "product_condition", placeholder: "Product condition" },
  { title: (<>Shipping charges <AsteriskLabel /></>), name: "shipping", placeholder: "Shipping charges" },
];

const WorkSamples = ({ updateindex, bxpData, setbxpData, setActiveTab }) => {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectCountry, setSelectCountry] = useState(null);
  const dispatch = useDispatch();
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    dispatch(GetCountry());
  }, [dispatch]);

  const initialValues = {
    country_id: bxpData?.country_id || "",
    country_title: bxpData?.country_title || "",
    product_condition: bxpData?.product_condition ? String(bxpData?.product_condition) : "1",
    shipping: bxpData?.shipping ? String(bxpData?.shipping) : "1",
    files: bxpData?.files || [],
  };

  const validationSchema = Yup.object().shape({
    country_id: Yup.string().required("Country is required").test("not-only-spaces", "Please enter a valid value", (value) => value.trim() !== ""),
    product_condition: Yup.string().required("Product condition is required"),
    shipping: Yup.string().required("Shipping charges is required").test("not-only-spaces", "Please enter a valid value", (value) => value.trim() !== ""),
    files: filesvalidationforstatusbase,
  });

  useEffect(() => {
    LoadCSSforfirstTime("Assets/scss/FirstTimeUsers.module.scss");
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    let updatedData = { ...bxpData, ...values };

    try {
      setbxpData(updatedData);
      setActiveTab("PricingTerms");
    } catch (error) {
      urtoast(error.message, 2);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (bxpData) {
      setSelectCountry({
        value: bxpData.country_id,
        label: bxpData.country_title,
      });
    }

  }, [bxpData])

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => (
          <Form>
            <div>
              {bxpDatatomap.map((prop, key) => {
                if (prop.name == "files") {
                  return (
                    <div className="form-group" key={key}>
                      <PortfolioImages
                        formik={formik}
                        doctype={1}
                      />
                      <ul className="border-ul">
                        <li>Images (JPG, PNG, JPEG up to 10MB)</li>
                      </ul>
                    </div>
                  );
                }
                if (prop.name == "product_condition") {
                  return (
                    <div key={key} className="form-group">
                      <label>{prop.title}</label>
                      <div className="label-check">
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="1" />
                          <span className="checkmark">Brand new</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="2" />
                          <span className="checkmark">Used</span>
                        </label>
                      </div>
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
                if (prop.name == "shipping") {
                  return (
                    <div key={key} className="form-group">
                      <label>{prop.title}</label>
                      <div className="label-check">
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="1" />
                          <span className="checkmark">Included</span>
                        </label>
                        <label className="checkbox-container">
                          <Field type="radio" name={prop.name} value="2" />
                          <span className="checkmark">Not included</span>
                        </label>
                      </div>
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
                if (prop.name == "description") {
                  return (
                    <>
                      <CustomReactQuill
                        value={formik.values[prop.name]}
                        formik={formik}
                        name={prop.name}
                        title={prop.title}
                      />
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                        style={{ color: "red" }}
                      />
                    </>
                  );
                }
                if (prop.name == "country_id") {
                  return (
                    <div className="form-group" key={key}>
                      <label>{prop.title}</label>
                      <ReactSelect
                        options={Array.isArray(countrylist) && countrylist.map((country) => ({
                          value: country.id,
                          label: country.title,
                        }))}
                        placeholder={prop.placeholder}
                        value={
                          formik.values?.country_id
                            ? {
                              value: formik.values.country_id,
                              label: formik.values.country_title,
                            }
                            : null
                        } onChange={(options) => {
                          setSelectCountry(options);
                          formik.setFieldValue("country_id", options.value);
                          formik.setFieldValue("country_title", options.label);
                        }}
                      />
                      <ErrorMessage
                        name={prop.name}
                        component="div"
                        className="error"
                      />
                    </div>
                  );
                }
                if (prop.name == "duration") {
                  return (
                    <NumberInputBox
                      type={"number"}
                      title={`No of ${formik.values?.duration_type === 1 ? "Hour" : formik.values?.duration_type === 2 ? "Days" : formik.values?.duration_type === 3 ? "Weeks" : "Months"}`}
                      name={prop.name}
                      placeholder={`No of ${formik.values?.duration_type === 1 ? "Hour" : formik.values?.duration_type === 2 ? "Days" : formik.values?.duration_type === 3 ? "Weeks" : "Months"} required`}
                      key={key}
                    />
                  );
                }
                return (
                  <FieldInput
                    title={prop.title}
                    name={prop.name}
                    placeholder={prop.placeholder}
                    key={key}
                  />
                );
              })}
              <div className="button-container">
                <div
                  style={loading ? disabledStyle : {}}
                  type="button"
                  className="prev-button btn w-100"
                  onClick={() => setActiveTab("BXPDetails")}
                >
                  Back
                </div>
                <div
                  className="next-button btn w-100"
                  type="submit"
                  onClick={formik.handleSubmit}
                >
                  {loading ? <LoginLoaderButton /> : "Next"}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default WorkSamples;
